import React from 'react'
import { ContentNotFound, ImageNotFound, TextLink, TextMassage } from './StyledNotFoundPAge'
import { NotFoundPage } from '../../../images';
const NotFound = () => {
    return (
        <ContentNotFound>
            <ImageNotFound src={NotFoundPage} />
            <TextMassage>
                عذرا، الصفحة غير موجودة!
            </TextMassage>
            <TextLink to='/'>
                الذهاب للرئيسية
            </TextLink>
        </ContentNotFound>
    )
}

export default NotFound